// navigation.js
let navigateFn;

export const setNavigator = (nav) => {
  navigateFn = nav;
};

/**
 * Wrapper around useNavigate that supports all options
 * @param {string | number} to - path or delta (like -1 for goBack)
 * @param {object} options - optional object { replace, state, relative }
 */
export const navigate = (to, options = {}) => {
  if (!navigateFn) {
    console.error("Navigator not set!");
    return;
  }
  navigateFn(to, options);
};
